import api from './api';

export const visiMisiService = {
    // PUBLIC
    getPublicVisiMisi: async () => {
        try {
            const response = await api.get('/visi-misi');
            return { success: true, data: response.data };
        } catch (error) {
            return {
                success: false,
                message: error.response?.data?.message || 'Gagal mengambil data'
            };
        }
    },

    // ADMIN
    getVisiMisiList: async () => {
        try {
            const response = await api.get('/visi-misi-admin');
            return { success: true, data: response.data };
        } catch (error) {
            return { success: false, message: 'Gagal mengambil data' };
        }
    },

    getVisiMisi: async (id) => {
        try {
            const response = await api.get(`/visi-misi-admin/${id}`);
            return { success: true, data: response.data };
        } catch (error) {
            return { success: false, message: 'Gagal mengambil data' };
        }
    },

    createVisiMisi: async (data) => {
        try {
            const response = await api.post('/visi-misi-admin', data);
            return { success: true, data: response.data };
        } catch (error) {
            return {
                success: false,
                message: error.response?.data?.message || 'Gagal menyimpan'
            };
        }
    },

    updateVisiMisi: async (id, data) => {
        try {
            const response = await api.put(`/visi-misi-admin/${id}`, data);
            return { success: true, data: response.data };
        } catch (error) {
            return {
                success: false,
                message: error.response?.data?.message || 'Gagal mengupdate'
            };
        }
    },

    deleteVisiMisi: async (id) => {
        try {
            const response = await api.delete(`/visi-misi-admin/${id}`);
            return { success: true };
        } catch (error) {
            return { success: false, message: 'Gagal menghapus' };
        }
    },
};